import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-leisure-form',
  templateUrl: './leisure-form.component.html',
  styleUrls: ['./leisure-form.component.css','../admin.css']
})
export class AdminLeisureFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/leisure-form/leisure-form.component.ts